import React from 'react';
import { connect } from 'react-redux';
import { Redirect, RouteComponentProps } from 'react-router-dom';

import { IRootState } from 'app/shared/reducers';
import { login, eIdLogin, eIDAuthentication, loginToken } from 'app/shared/reducers/authentication';
import LoginModal from './login-modal';
import { getUrlParameter, Storage } from 'react-jhipster';
export interface ILoginProps extends StateProps, DispatchProps, RouteComponentProps<{}> {}

export interface ILoginState {
  showModal: boolean;
  type: String;
}

export class Login extends React.Component<ILoginProps, ILoginState> {
  state: ILoginState = {
    showModal: this.props.showModal,
    type: 'username'
  };

  componentDidUpdate(prevProps: ILoginProps, prevState) {
    // if (this.props !== prevProps) {
    //   this.setState({ showModal: this.props.showModal });
    // }
  }

  componentWillMount() {
    // const code = getUrlParameter('code', this.props.location.search);
    // console.log('code: ' + code);
    // const state = getUrlParameter('session_state', this.props.location.search);
    // if (code && code !== '') {
    //   this.props.eIDAuthentication(code, state);
    // } else {
    //   window.location.href = oauth2.URL_DICHVUCONG;
    // }
  }

  componentDidMount() {}

  handleLogin = (username, password, rememberMe = false) => {
    this.props.login(username, password, rememberMe);
  };

  handleLoginToken = (certSerial, certBase64) => {
    this.props.loginToken(certSerial, certBase64);
  };

  handleLoginEID = (username, password, rememberMe = false) => {
    if (/^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/.test(username)) {
      this.setState({
        type: 'email'
      });
    } else if (/^[0]?[0-9]\d{9}$/.test(username)) {
      this.setState({
        type: 'phone'
      });
    } else {
      this.setState({
        type: 'username'
      });
    }
    this.props.eIdLogin(username, password, rememberMe, this.state.type);
  };

  handleAuthorizationEID = () => {
    if (this.props.location.state.code) {
    }
  };

  handleClose = () => {
    this.setState({ showModal: false });
  };

  render() {
    const { location, isAuthenticated, account } = this.props;
    //const { from } = location.state || { from: { pathname: '/', search: location.search } };
    const { showModal } = this.state;
    // if (isAuthenticated) {
    //   Storage.session.set('userInfo', account);

    //   return (
    //     <Redirect
    //       to={{
    //         pathname: '/userprofile',
    //         state: {
    //           userInfo: account
    //         }
    //       }}
    //     />
    //   );
    // }
    return (
      <div>{/* {window['styleUserProfile']()} */}</div>
      // <LoginModal
      //   showModal={showModal}
      //   handleLogin={this.handleLogin}
      //   handleLoginEID={this.handleLoginEID}
      //   handleAuthorizationEID={this.handleAuthorizationEID}
      //   handleClose={this.handleClose}
      //   loginError={this.props.loginError}
      //   handleLoginToken={this.handleLoginToken}
      // />
    );
  }
}

const mapStateToProps = ({ authentication }: IRootState) => ({
  isAuthenticated: authentication.isAuthenticated,
  account: authentication.account,
  loginError: authentication.loginError,
  showModal: authentication.showModalLogin
});

const mapDispatchToProps = { login, eIdLogin, eIDAuthentication, loginToken };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);
